import Vue from "vue";
import Router from "vue-router";
import thanks from "@/components/mailing/thanks";
import narrowTemplate from "@/components/partials/misc/narrowTemplate";
Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/:campaign/:slug",
      component: narrowTemplate,
      children: [{ path: "/", component: thanks }],
    },
  ],
});
